import makeService from './api';

export default makeService('change_logs');
